module.exports = __webpack_public_path__ + "88f95a9b0e9b3d079097c8e2c1630081.svg";